import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostKundenFinanzenCommandServiceModule } from '..';
import { PostKundenFinanzenCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    PostKundenFinanzenCommandServiceModule
  ],
  declarations: [PostKundenFinanzenCommandComponent],
  exports: [PostKundenFinanzenCommandComponent],

})
export class PostKundenFinanzenCommandComponentModule { }
